import React from "react";
import Navigation from "../components/Navigation";
import SecondHeader from "../components/SecondHeader";
import AboutHeaderImg from "../assets/images/about-header-img.jpg";
import { Box, Container, Typography } from "@mui/material";
import Footer from "../components/Footer";
import ReviewsSection from "../components/ReviewsComponents/ReviewsSection";
import WhyChooseUs from "../components/WhyChooseUsComponents/WhyChooseUs";
import reviewImgAbout from "../assets/images/review-img-about.jpg";
import AboutLocationMap from "../components/AboutLocationMap";

function About() {
  return (
    <div className="App">
      <Box>
        {/* Navigation Bar */}
        <Navigation />

        {/* Second Header Section */}
        <SecondHeader
          title="About us"
          img={AboutHeaderImg}
          imgPosition="center"
        />

        {/* Who We Are Section */}
        <Box
          sx={{
            backgroundColor: "#00bf63",
            paddingY: "3rem",
            paddingX: { xs: "1rem", md: "3rem" },
            textAlign: "center",
            marginTop: "4rem",
            width: { xs: '85%', md: '70%' }, // Responsive width
            marginLeft: "auto", // Center horizontally
            marginRight: "auto",
            borderRadius: "6px", // Border radius added
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)", // Optional: subtle shadow for better look
          }}
        >
          <Container>
            <Box
              sx={{
                maxWidth: "800px",
                margin: "0 auto",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  marginBottom: "1rem",
                }}
              >
                Who We Are
              </Typography>
              <Typography variant="body1" sx={{ color: "white" }}>
                PR-Builders, established in 2010, is a trusted construction company in East Tambaram,
                Chennai. We work as builders and civil contractors across Tambaram,
                Vengadamangalam, and South Chennai—delivering homes, extensions, and
                commercial structures. With a strong commitment to quality and innovation,
                we have successfully completed over 100 projects. Our focus on excellence,
                timely delivery, and customer satisfaction has made us a go-to construction partner in Tamil Nadu.
              </Typography>
            </Box>
          </Container>
        </Box>

        {/* Why Choose Us Section */}
        <WhyChooseUs />

        {/* Reviews Section */}
        <Box
          sx={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75)), url(${reviewImgAbout})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <Container>
            <ReviewsSection />
          </Container>
        </Box>

        <AboutLocationMap />

        {/* Footer */}
        <Footer />
      </Box>
    </div>
  );
}

export default About;
